var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"create-title":"Create NET","update-title":"Edit NET: ","updateTitleKey":"Address"}})
}
var staticRenderFns = []

export { render, staticRenderFns }